'use client'

import { CommonBenefits } from '@/features/common/common-benefits'

export const JobsBenefits = () => {
    return (
        <section className="mb-10 md:mb-16 w-full">
            <CommonBenefits
                tBaseKey="jobs.benefits"
                titleClassName="text-center md:text-center text-[24px] md:text-[32px]"
            />
        </section>
    )
}
